import { type MobilityModuleSpecsFragment } from '../../../../api/fragments/MobilityModuleSpecs';
import MobilityEmailContentForm from './MobilityEmailContentForm';
import MobilityModuleDetails from './MobilityModuleDetails';
import HeaderTabs from './shared';

export type MobilityModuleDetailsInnerProps = {
    module: MobilityModuleSpecsFragment;
    activeTab: HeaderTabs;
};

const MobilityModuleDetailsInner = ({ module, activeTab }: MobilityModuleDetailsInnerProps) => {
    switch (activeTab) {
        case HeaderTabs.MainDetails:
            return <MobilityModuleDetails module={module} />;

        case HeaderTabs.EmailContent:
            return <MobilityEmailContentForm module={module} />;

        default:
            throw new Error('HeaderTabs not support');
    }
};

export default MobilityModuleDetailsInner;
